/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nutrition_Per_PortionInputs */

const en_nutrition_per_portion = /** @type {(inputs: Nutrition_Per_PortionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per portion`)
};

const de_nutrition_per_portion = /** @type {(inputs: Nutrition_Per_PortionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Portion`)
};

/**
* | output |
* | --- |
* | "Per portion" |
*
* @param {Nutrition_Per_PortionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrition_per_portion = /** @type {((inputs?: Nutrition_Per_PortionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrition_Per_PortionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrition_per_portion(inputs)
	return en_nutrition_per_portion(inputs)
});